export const termsContent = {
  shared: {
    overViewOfDigit: (
      <>
        <p>
          The Arizona Board of Regents for and on behalf of Arizona State University (ASU,
          us, or we) developed Digit, an online tool that surfaces personalized learning
          content relating to math, science, computer science, and more, into structured
          courses, for the purpose of providing students with practice and graded
          activities relevant to that subject.
        </p>
      </>
    ),

    yourChoices: (
      <>
        <p>
          <span style={{ fontWeight: "bold" }}>Emails.</span> You may change previously
          expressed preferences regarding how we use information you provide on or through
          Digit. For example, if you have provided your contact information and receive
          periodic emails from us, you may decide to stop receiving those emails by
          clicking the “unsubscribe” link in an email’s footer. Note that we may still
          send you emails regarding your usage of Digit.
        </p>
        <p>
          <span style={{ fontWeight: "bold" }}>Previously Expressed Preferences.</span> If
          you have created an account on this Digit, you may be able to access, update or
          correct your information through your account settings. Otherwise, you may
          contact us to update your information. Please contact us using the information
          provided below. We will respond to you within a reasonable time and, in any
          case, within the time limits established by applicable law. We may ask you for
          additional information to verify your identity. In most cases, we will provide
          access and correct or delete any inaccurate information you discover. In some
          cases, however, we may limit or deny your request if the law permits or requires
          us to do so or if we are unable to verify your identity.
        </p>
        <p>
          <span style={{ fontWeight: "bold" }}>Do Not Track Signals.</span> Some web
          browsers (such as Safari, Internet Explorer, Firefox and Chrome) have a “Do Not
          Track” (DNT) feature that tells websites that users do not want to have their
          online activity tracked. Not all browsers offer a DNT option and DNT signals are
          not yet uniform. For this reason, ASU does not respond to DNT signals.
        </p>
      </>
    ),

    children: (
      <>
        {" "}
        <p>
          Digit is not intended for children or minors under the age of thirteen years
          without the permission of a parent or guardian. If you believe that a child has
          submitted Personal Data on or through Digit without the consent and supervision
          of a parent or guardian, please contact us using the information provided below
          so that we can take appropriate action.
        </p>
      </>
    ),

    generalTerms: (
      <>
        <p>
          We reserve the right to suspend or discontinue your use of Digit if you use, or
          we suspect you use, Digit in a manner inconsistent with the Digit Terms, the ASU
          Terms, the ASU Privacy Policy or any applicable laws, rules, and regulations. In
          addition to suspension or discontinuance of your use of Digit, we may take
          appropriate administrative and/or legal action, as we deem necessary.
        </p>
        <p>
          ASU’s failure to enforce any provision of this Policy will not constitute a
          waiver of any other provision.
        </p>
        <p>
          All questions or disputes regarding Digit or this Policy will be resolved by ASU
          in its sole discretion. Please direct questions or disputes to ASUDigit@asu.edu.
          All decisions made by ASU or its designated agents regarding Digit, your use of
          Digit, and this Policy are final.
        </p>
        <p>Your use of Digit is subject to all applicable laws and regulations.</p>
        <p>
          <span style={{ fontWeight: "bold" }}>Your Account Registration.</span> If you
          create an account on Digit (a “User Account”) and submit information to us, you
          must ensure that such information is accurate. You must promptly update such
          information if it changes.
        </p>
        <p>
          <span style={{ fontWeight: "bold" }}>Accounts are Personal.</span> You may not
          use anyone else’s account at any time. You may not buy, sell, rent, or lease
          access to your User Account or your username. You will not share or otherwise
          transfer your User Account or credentials.
        </p>
        <p>
          <span style={{ fontWeight: "bold" }}>Security of Your Account.</span> You are
          entirely responsible for maintaining the confidentiality of your password and
          account. You are entirely responsible for any and all activities that occur
          under your User Account. You agree to notify ASU immediately of any unauthorized
          use of your account or any other breach of security. We will not be liable for
          any loss, damages, liability, expenses or attorneys’ fees that you may incur as
          a result of someone else using your password or User Account, either with or
          without your knowledge. You will be liable for losses, damages, liability,
          expenses and attorneys’ fees incurred by ASU or a third party due to someone
          else using your User Account, regardless of whether they are authorized.
        </p>
      </>
    ),

    permittedUse: (
      <>
        <p>
          You are granted a limited, non-transferable license to access and use the
          platform and its content solely for non-commercial, and educational purposes.
          Access is limited to online use through the ASU-provided learning management
          system (the ASU Platform) with a valid ASUrite ID, or through ASU-approved
          partnerships with other institutions; offline and downloadable access is
          prohibited.
        </p>
        <p>You agree not to:</p>
        <ul>
          <li>
            Copy, reproduce, print, or transmit any portion of the content exceeding two
            pages or 2,000 characters.
          </li>
          <li>
            Sell, distribute, sublicense, share, or publicly display any content or your
            access credentials.
          </li>
          <li>Download, burn, or otherwise make electronic copies of any content.</li>
          <li>
            Use, display, or retain any content beyond the authorized access period.
          </li>
          <li>
            Create derivative works based on the content or commingle it with third-party
            materials.
          </li>
          <li>
            Use automated tools (e.g., bots, spiders, scrapers) or take any action that
            imposes an unreasonable burden on ASU's technical infrastructure.
          </li>
          <li>
            Interfere with the platform’s operation, restrict others’ access, or
            misrepresent ASU’s affiliation or endorsement.
          </li>
          <li>
            Circumvent, disable, or otherwise interfere with digital rights management
            tools, password protections, access controls, or other technological
            protection measures.
          </li>
          <li>
            Use the content with or for the training, development, or deployment of
            artificial intelligence (AI) systems.
          </li>
        </ul>
        <p>
          The content is provided “as is,” without warranties of any kind, express or
          implied, including merchantability or fitness for a particular purpose. Under no
          circumstances shall ASU or its licensors be liable for indirect, special, or
          consequential damages, including but not limited to lost time, money, profits,
          or goodwill.
        </p>
      </>
    ),

    disclaimer: (
      <>
        <p>
          Certain content accessed through this platform may relate to scientific,
          medical, or health-related topics. While efforts are made to provide accurate
          and up-to-date information, ASU and its licensors make no representations or
          warranties regarding the completeness, accuracy, or currentness of such content.
          Users are solely responsible for verifying any information before relying on it
          for clinical, educational, or decision-making purposes. This content is provided
          for educational use only and is not intended to substitute for professional
          advice, diagnosis, or treatment. ASU and its licensors disclaim any
          responsibility for errors, omissions, or outcomes related to the use of this
          information.
        </p>
      </>
    ),
  },

  higherEd: {
    intro: (
      <>
        <p>
          PLEASE READ ALL OF THE FOLLOWING CAREFULLY BECAUSE THESE TERMS OF USE AND
          PRIVACY POLICY (collectively{" "}
          <span style={{ fontWeight: "bold" }}>Digit Terms</span>), ALONG WITH ASU’S
          PRIVACY POLICY AND TERMS OF USE GOVERNS YOUR USE OF DIGIT. FOR PURPOSES OF THESE
          DIGIT TERMS:
        </p>

        <ul>
          <li>“WE” OR “US” REFERS TO ASU</li>
          <li>
            “YOU” REFERS TO THE USERS OF ORCHARD, INCLUDING:
            <ul style={{ marginTop: "8px" }}>
              <li>“STUDENTS” or “LEARNER” using Digit to learn</li>
              <li>
                “EDUCATORS” REFERS TO ORCHARD USERS INVOLVED IN DELIVERING EDUCATIONAL
                MATERIALS TO YOU, SUCH AS TEACHERS, AIDES, AND TUTORS
              </li>
              <li>
                “ADMINISTRATORS” REFERS TO ORCHARD USERS INVOLVED IN ADMINISTRATION, SUCH
                AS SCHOOL OR DISTRICT OFFICIALS.
              </li>
            </ul>
          </li>
        </ul>

        <p>
          IF YOU DO NOT WANT TO CONSENT TO THESE TERMS, PLEASE DO NOT PROVIDE YOUR
          PERSONAL DATA OR USE DIGIT.
        </p>

        <p>BY CLICKING ON THE “I CONSENT” BUTTON BELOW, YOU CONSENT TO:</p>

        <ol>
          <li>
            ASU using the Personal and Performance Data, defined further in this document,
            you provide to us to interact with you regarding any information you request.
            We do not sell user data collected from Digit users.
          </li>
          <li>
            The most recent terms of{" "}
            <a
              href="https://www.asu.edu/privacy/"
              target="_blank"
              rel="noreferrer"
              // onClick={() =>
              //   handleLink("https://www.asu.edu/privacy/", {
              //     event: "link",
              //     action: "click",
              //     name: "onclick",
              //     type: "internal link",
              //     region: "main content",
              //     section: "digit terms",
              //     text: "asu's privacy statement",
              //     component: "terms & conditions",
              //   })
              // }
            >
              ASU'S PRIVACY STATEMENT.
            </a>
          </li>
          <li>
            The most recent terms of{" "}
            <a
              href="https://www.asu.edu/about/terms-of-use"
              target="_blank"
              rel="noreferrer"
              // onClick={() =>
              //   handleLink("https://www.asu.edu/about/terms-of-use", {
              //     event: "link",
              //     action: "click",
              //     name: "onclick",
              //     type: "internal link",
              //     region: "main content",
              //     section: "digit terms",
              //     text: "asu's terms of use",
              //     component: "terms & conditions",
              //   })
              // }
            >
              ASU’S TERMS OF USE.
            </a>
          </li>
          <li>
            The most recent terms of{" "}
            <a
              href="https://www.asu.edu/about/copyright-trademark"
              target="_blank"
              rel="noreferrer"
              // onClick={() =>
              //   handleLink("https://www.asu.edu/about/copyright-trademark", {
              //     event: "link",
              //     action: "click",
              //     name: "onclick",
              //     type: "internal link",
              //     region: "main content",
              //     section: "digit terms",
              //     text: "copyright trademark",
              //     component: "terms & conditions",
              //   })
              // }
            >
              ASU'S COPYRIGHT AND TRADEMARK STATEMENT.
            </a>
          </li>
          <li>
            The most recent terms of the{" "}
            <a
              href="https://asuorchard.asu.edu/legal"
              target="_blank"
              rel="noreferrer"
              // onClick={() =>
              //   handleLink("https://www.asu.edu/about/copyright-trademark", {
              //     event: "link",
              //     action: "click",
              //     name: "onclick",
              //     type: "internal link",
              //     region: "main content",
              //     section: "digit terms",
              //     text: "copyright trademark",
              //     component: "terms & conditions",
              //   })
              // }
            >
              Orchard Terms of Use
            </a>
            . Orchard is a platform used in Digit to deliver personalized learning
            experiences.
          </li>
          <li>The Digit Terms as set forth below.</li>
        </ol>

        <p>
          ASU MAY MODIFY THESE POLICY TERMS FROM TIME TO TIME IN OUR SOLE DISCRETION AND
          WITHOUT NOTICE TO YOU. ASU WILL POST THE MOST RECENT REVISION DATE AT THE END OF
          THIS POLICY. YOUR CONTINUED USE OF DIGIT AFTER ANY MODIFICATION OF THIS POLICY
          MEANS YOU HAVE ACCEPTED THE MODIFICATIONS.
        </p>
      </>
    ),
    whatDigitCollects: (
      <>
        <span
          style={{
            fontWeight: "bold",
            marginRight: "0.8rem",
          }}>
          For students and learners
        </span>

        <p>
          For ASU affiliated courses: Digit provides a series of practice activities and
          provides scores based on your provided answers (collectively your “
          <span style={{ fontWeight: "bold" }}>Performance Data</span>”). We use your
          answers to provide you with additional support paths and practice content, and
          often to provide a grade for the associated course assignment.
        </p>
        <p>
          In addition to the information that we may collect about you as stated in the
          ASU Privacy Policy, to use Digit, we may require you to provide us with the
          following information (collectively referred to as “
          <span style={{ fontWeight: "bold" }}>Personal Data</span>”):
        </p>

        <ul>
          <li>First name</li>
          <li>Last name</li>
          <li>Your Email Address</li>
          <li>Name of your school</li>
          <li>Login Credentials</li>
        </ul>

        <p>
          If you are affiliated with a school or organization, your Personal Data may be
          provided to us from that school or organization.
        </p>

        <span
          style={{
            fontWeight: "bold",
            marginRight: "0.8rem",
          }}>
          For Educators
        </span>

        <p>
          <span style={{ fontWeight: "bold" }}>Digit</span> logs your interactions with
          the platform to allow us to better understand engagement and usage of the
          platform (collectively your “Performance Data”).
        </p>
      </>
    ),

    howWeUseYourDigitData: (
      <>
        <span
          style={{
            fontWeight: "bold",
            marginRight: "0.8rem",
          }}>
          For students and learners
        </span>
        <p>
          Digit uses your Performance Data and Personal Data to provide you feedback,
          hints, if available, and supplemental learning materials. We may also use your
          Performance and Personal Data to send you updates and information regarding
          Digit.
        </p>
        <p>
          We may also use your Performance and Personal Data to communicate with your
          school if we have a contract with your school or school district, to help your
          school develop, update, and track learning gaps, both on an aggregate and
          individual basis. If your school uses the Digit Dashboard, your consent to this
          Policy includes a consent to allow ASU to share your Performance and Personal
          Data with your school, teacher, teacher aides, or tutors. We may also share your
          Performance and Personal Data with your instructors, instructor aides, tutors,
          and any other individuals involved with your academic success. We do not allow
          any schools or teaching individuals to share your Personal Data unless permitted
          by applicable law.
        </p>

        <span
          style={{
            fontWeight: "bold",
            marginRight: "0.8rem",
          }}>
          For Educators
        </span>

        <p>
          Digit uses your Performance and Personal Data to understand engagement and usage
          of the platform.
        </p>

        <span
          style={{
            fontWeight: "bold",
            marginRight: "0.8rem",
          }}>
          For all users
        </span>

        <p>
          We keep your Performance and Personal Data indefinitely and may archive it; use
          it in an aggregated and de-identified form for research and analytics purposes;
          use it for future communications with you if you consent; use it to establish,
          exercise, and defend legal claims; use it for reasons of substantial public
          interest, including archiving purposes; and use it for historical, scientific,
          research, or statistical purposes, subject to appropriate safeguards and any
          consents required by applicable laws. When reasonably possible, we process your
          Performance and Personal Data on an anonymized, pseudonymized, and/or
          de-identified basis.
        </p>
        <p>
          If you’d like us to remove your data, please contact us using the information
          provided below. Please note, certain laws or regulations, such as the Family
          Educational Rights and Privacy Act (“FERPA”) prohibit us from deleting certain
          records.
        </p>
        <p>
          Digit may use session analytics tools such as Google Analytics or FullStory to
          understand user behavior and devices/browsers used, identify opportunities for
          usability improvements, and troubleshoot technical issues. These tools collect
          anonymized data, including devices and browsers used, geographical location,
          usage data such as clicks, navigation paths, and system information, but not
          keystroke or sensitive input fields.
        </p>
      </>
    ),

    accessibility: (
      <>
        <p>
          We are committed to making Digit accessible to all learners. We regularly
          evaluate Digit for compliance with the Web Content Accessibility Guidelines
          (WCAG) and relevant provisions of the Americans with Disabilities Act (ADA). The
          decision to use or continue using Digit—including any actions taken by
          institutions, educators, students, or their representatives—constitutes an
          acknowledgment of Digit’s accessibility features and an acceptance of its
          compliance with applicable standards. Digit shall not be held liable for any
          claims, demands, damages, or legal actions arising from or related to compliance
          with the ADA or other accessibility laws or requirements, whether such claims
          are made by the institution, its representatives, students, their
          representatives, or any third parties. Should additional accessibility help be
          needed, ASU students can contact{" "}
          <a
            href="https://eoss.asu.edu/accessibility"
            target="_blank"
            rel="noreferrer"
            // onClick={() =>
            //   handleLink("https://eoss.asu.edu/accessibility", {
            //     event: "link",
            //     action: "click",
            //     name: "onclick",
            //     type: "internal link",
            //     region: "main content",
            //     section: "digit terms",
            //     text: "accessibility",
            //     component: "terms & conditions",
            //   })
            // }
          >
            Student Accessibility and Inclusive Learning Services (SAILS).
          </a>
        </p>
      </>
    ),

    limitation: (
      <>
        <p>
          ASU is not responsible for technical, network, electronic, computer, hardware or
          software malfunctions, or inaccurate transmission of data, including errors or
          difficulties that may occur in connection with the administration of Digit or
          communicating with you. ASU is also not responsible for any incorrect or
          inaccurate information, whether caused by Digit users, tampering, hacking, or by
          any equipment or programming associated with or used in Digit.
        </p>
        <p>
          You accept all responsibility for, and hereby release ASU of and from, any
          claims, liabilities, damages or expenses that may arise from your use of Digit,
          or for any harm or injury caused by your use of Digit. ASU is not responsible
          for any incorrect or inaccurate information, whether caused by Digit users,
          tampering, hacking, or by any equipment or programming associated with or used
          in Digit.
        </p>
        <p>
          UNDER NO CIRCUMSTANCES IS ASU LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
          SPECIAL OR CONSEQUENTIAL DAMAGES ARISING OUT OF YOUR USE OF DIGIT, EVEN IF ASU
          HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. YOU AGREE THAT THE
          LIMITATIONS OF LIABILITY SET FORTH IN THIS SECTION WILL SURVIVE ANY TERMINATION
          OR EXPIRATION OF THIS AGREEMENT. ASU DISCLAIMS ANY REPRESENTATIONS OR
          WARRANTIES, EXPRESSED OR IMPLIED, REGARDING DIGIT, INCLUDING WARRANTIES OF
          FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT.
        </p>
        <p>
          These Terms will be governed by the laws of the State of Arizona without regard
          to any conflicts of laws principles. ASU’s obligations are subject to the
          regulations/policies of the Arizona Board of Regents. Any proceeding arising out
          of or relating to this Agreement or your use of Digit will be conducted in
          Maricopa County, Arizona. You consent to such jurisdiction, and waive any
          objection you may have to venue or convenience of forum.
        </p>
        <p>
          <span style={{ fontWeight: "bold" }}>Dispute Resolution.</span> If a dispute
          arises under the Digit Terms, the parties will exhaust all applicable
          administrative remedies provided for under Arizona Board of Regents Policy
          3-809.
        </p>
        <p>
          <span style={{ fontWeight: "bold" }}>Arbitration.</span> If and to the extent
          required, the parties agree to arbitrate disputes filed in Arizona Superior
          Court that are subject to mandatory arbitration pursuant to ARS § 12-133.
        </p>
        <p>
          Effective: June, 2020{<br />}Updated: December, 2025{<br />}Contact Information:
          If you have any questions or concerns please contact us at:
        </p>
        <p>Email: ASUDigit@asu.edu</p>
        <p>
          You understand that your acceptance below constitutes your consent to the
          collection, use, and disclosure of your personal information for the above
          purposes. If you do not consent, you may not proceed.
        </p>
      </>
    ),

    aiUse: (
      <>
        <p>
          Under no circumstances may course content be used with, or incorporated into,
          any artificial intelligence (AI) tools, platforms, or systems. This includes—but
          is not limited to—using such content to train, fine-tune, validate, test, or
          enhance any AI model or service.
        </p>
        <p>
          You are expressly prohibited from uploading, copying/pasting, or inputting
          course content into AI platforms (including but not limited to ChatGPT, Gemini,
          Claude, any platform that uses these or similar language models to perform
          tasks) for any purpose, including academic study, tutoring, summarization,
          rewording, or translation. This prohibition applies even if the intent is
          non-commercial or for personal learning. Any such use may violate intellectual
          property rights and is strictly forbidden under these Terms.
        </p>
      </>
    ),
  },
  k12: {
    intro: (
      <>
        <p>
          PLEASE READ ALL OF THE FOLLOWING CAREFULLY BECAUSE THESE TERMS OF USE AND
          PRIVACY POLICY (collectively{" "}
          <span style={{ fontWeight: "bold" }}>Digit Terms</span>), ALONG WITH ASU’S
          PRIVACY POLICY AND TERMS OF USE GOVERNS YOUR USE OF DIGIT. FOR PURPOSES OF THESE
          DIGIT TERMS:
        </p>

        <ul>
          <li>“WE” OR “US” REFERS TO ASU</li>
          <li>
            “YOU” REFERS TO THE USERS OF ORCHARD, INCLUDING:
            <ul style={{ marginTop: "8px" }}>
              <li>“STUDENTS” or “LEARNER” using Digit to learn</li>
              <li>
                “EDUCATORS” REFERS TO ORCHARD USERS INVOLVED IN DELIVERING EDUCATIONAL
                MATERIALS TO YOU, SUCH AS TEACHERS, AIDES, AND TUTORS
              </li>
              <li>
                “ADMINISTRATORS” REFERS TO ORCHARD USERS INVOLVED IN ADMINISTRATION, SUCH
                AS SCHOOL OR DISTRICT OFFICIALS.
              </li>
            </ul>
          </li>
        </ul>

        <p>
          IF YOU DO NOT WANT TO CONSENT TO THESE TERMS, PLEASE DO NOT PROVIDE YOUR
          PERSONAL DATA OR USE DIGIT.
        </p>

        <p>BY CLICKING ON THE “I CONSENT” BUTTON BELOW, YOU CONSENT TO:</p>

        <ol>
          <li>
            ASU using the Personal and Performance Data, defined further in this document,
            you provide to us to interact with you regarding any information you request.
            We do not sell user data collected from Digit users.
          </li>
          <li>
            The most recent terms of{" "}
            <a
              href="https://www.asu.edu/privacy/"
              target="_blank"
              rel="noreferrer"
              // onClick={() =>
              //   handleLink("https://www.asu.edu/privacy/", {
              //     event: "link",
              //     action: "click",
              //     name: "onclick",
              //     type: "internal link",
              //     region: "main content",
              //     section: "digit terms",
              //     text: "asu's privacy statement",
              //     component: "terms & conditions",
              //   })
              // }
            >
              ASU'S PRIVACY STATEMENT.
            </a>
          </li>
          <li>
            The most recent terms of{" "}
            <a
              href="https://www.asu.edu/about/terms-of-use"
              target="_blank"
              rel="noreferrer"
              // onClick={() =>
              //   handleLink("https://www.asu.edu/about/terms-of-use", {
              //     event: "link",
              //     action: "click",
              //     name: "onclick",
              //     type: "internal link",
              //     region: "main content",
              //     section: "digit terms",
              //     text: "asu's terms of use",
              //     component: "terms & conditions",
              //   })
              // }
            >
              ASU’S TERMS OF USE.
            </a>
          </li>
          <li>
            The most recent terms of{" "}
            <a
              href="https://www.asu.edu/about/copyright-trademark"
              target="_blank"
              rel="noreferrer"
              // onClick={() =>
              //   handleLink("https://www.asu.edu/about/copyright-trademark", {
              //     event: "link",
              //     action: "click",
              //     name: "onclick",
              //     type: "internal link",
              //     region: "main content",
              //     section: "digit terms",
              //     text: "copyright trademark",
              //     component: "terms & conditions",
              //   })
              // }
            >
              ASU'S COPYRIGHT AND TRADEMARK STATEMENT.
            </a>
          </li>
          <li>The Digit Terms as set forth below.</li>
        </ol>

        <p>
          ASU MAY MODIFY THESE POLICY TERMS FROM TIME TO TIME IN OUR SOLE DISCRETION AND
          WITHOUT NOTICE TO YOU. ASU WILL POST THE MOST RECENT REVISION DATE AT THE END OF
          THIS POLICY. YOUR CONTINUED USE OF DIGIT AFTER ANY MODIFICATION OF THIS POLICY
          MEANS YOU HAVE ACCEPTED THE MODIFICATIONS.
        </p>
      </>
    ),
    whatDigitCollects: (
      <>
        <>
          <span
            style={{
              fontWeight: "bold",
              marginRight: "0.8rem",
            }}>
            For learners
          </span>

          <p>
            Digit asks a series of practice problem questions and identifies areas of
            misconception or need for additional math support (collectively your “{" "}
            <span style={{ fontWeight: "bold" }}>Performance Data</span>”)”). We use your
            answers to analyze and provide you information to assist with math concepts
            and learning.
          </p>
          <p>
            In addition to the information that we may collect about you as stated in the
            ASU Privacy Policy, to use Digit, we may require you to provide us with the
            following information (collectively referred to as “
            <span style={{ fontWeight: "bold" }}>Personal Data</span>”):
          </p>

          <ul>
            <li>First name</li>
            <li>Last name</li>
            <li>Your Email Address</li>
            <li>Name of your school</li>
            <li>Grade</li>
            <li>Your highest level of math education</li>
            <li>Login Credentials</li>
          </ul>

          <p>
            If you are affiliated with a school or organization, your Personal Data may be
            provided to us from that school or organization.
          </p>

          <span
            style={{
              fontWeight: "bold",
              marginRight: "0.8rem",
            }}>
            For Faculty and Instructors
          </span>

          <p>
            Digit logs your interactions with the platform to allow us to better
            understand engagement and usage of the platform (collectively your
            “Performance Data”).
          </p>
        </>
      </>
    ),

    howWeUseYourDigitData: (
      <>
        <span
          style={{
            fontWeight: "bold",
            marginRight: "0.8rem",
          }}>
          For learners
        </span>
        <p>
          Digit uses your Performance Data and Personal Data to provide you feedback,
          hints, if available, and supplemental learning materials. We may also use your
          Performance and Personal Data to provide you information regarding ASU, specific
          courses and programs offered by ASU that may be of interest to you based on the
          results of your Digit use, and to send you updates and information regarding
          Digit.
        </p>
        <p>
          We may also use your Performance and Personal Data to communicate with your
          school if we have a contract with your school or school district, to help your
          school develop, update, and track learning gaps, both on an aggregate and
          individual basis. If your school uses the Digit Dashboard, your consent to this
          Policy includes a consent to allow ASU to share your Performance and Personal
          Data with your school, teacher, teacher aides, or tutors. We may also share your
          Performance and Personal Data with your instructors, instructor aides, tutors,
          and any other individuals involved with your academic success. We do not allow
          any schools or teaching individuals to share your Personal Data unless permitted
          by applicable law.
        </p>

        <span
          style={{
            fontWeight: "bold",
            marginRight: "0.8rem",
          }}>
          For teachers and instructors.
        </span>

        <p>
          Digit uses your Performance and Personal Data to understand engagement and usage
          of the platform.
        </p>

        <span
          style={{
            fontWeight: "bold",
            marginRight: "0.8rem",
          }}>
          For all users
        </span>

        <p>
          We keep your Performance and Personal Data indefinitely and may archive it; use
          it in an aggregated and de-identified form for research and analytics purposes;
          use it for future communications with you if you consent; use it to establish,
          exercise, and defend legal claims; use it for reasons of substantial public
          interest, including archiving purposes; and use it for historical, scientific,
          research, or statistical purposes, subject to appropriate safeguards and any
          consents required by applicable laws. When reasonably possible, we process your
          Performance and Personal Data on an anonymized, pseudonymized, and/or
          de-identified basis.
        </p>
        <p>
          If you’d like us to remove your data, please contact us using the information
          provided below. Please note, certain laws or regulations, such as the Family
          Educational Rights and Privacy Act (“FERPA”) prohibit us from deleting certain
          records.
        </p>
        <p>
          Digit may use session analytics tools such as Google Analytics or FullStory to
          understand user behavior and devices/browsers used, identify opportunities for
          usability improvements, and troubleshoot technical issues. These tools collect
          anonymized data, including devices and browsers used, geographical location,
          usage data such as clicks, navigation paths, and system information, but not
          keystroke or sensitive input fields.
        </p>
      </>
    ),

    accessibility: (
      <>
        <p>
          We are committed to making Digit accessible to all learners. We regularly
          evaluate Digit for compliance with the Web Content Accessibility Guidelines
          (WCAG) and relevant provisions of the Americans with Disabilities Act (ADA). The
          decision to use or continue using Digit—including any actions taken by
          institutions, educators, students, or their representatives—constitutes an
          acknowledgment of Digit’s accessibility features and an acceptance of its
          compliance with applicable standards. Digit shall not be held liable for any
          claims, demands, damages, or legal actions arising from or related to compliance
          with the ADA or other accessibility laws or requirements, whether such claims
          are made by the institution, its representatives, students, their
          representatives, or any third parties.
        </p>
      </>
    ),

    limitation: (
      <>
        <p>
          ASU is not responsible for technical, network, electronic, computer, hardware or
          software malfunctions, or inaccurate transmission of data, including errors or
          difficulties that may occur in connection with the administration of Digit or
          communicating with you. ASU is also not responsible for any incorrect or
          inaccurate information, whether caused by Digit users, tampering, hacking, or by
          any equipment or programming associated with or used in Digit. In its algebra
          course, Digit utilizes an AI (Artificial Intelligence), which is programmed to
          provide helpful guidance based on available data and predefined algorithms.
          While this AI aims to offer accurate and helpful responses, its information may
          not always be the best possible option. Learners are encouraged to verify with
          their teacher or parent. We do not assume liability for actions taken based on
          the AI’s responses.
        </p>
        <p>
          You accept all responsibility for, and hereby release ASU of and from, any
          claims, liabilities, damages or expenses that may arise from your use of Digit,
          or for any harm or injury caused by your use of Digit. ASU is not responsible
          for any incorrect or inaccurate information, whether caused by Digit users,
          tampering, hacking, or by any equipment or programming associated with or used
          in Digit.
        </p>
        <p>
          UNDER NO CIRCUMSTANCES IS ASU LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
          SPECIAL OR CONSEQUENTIAL DAMAGES ARISING OUT OF YOUR USE OF DIGIT, EVEN IF ASU
          HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. YOU AGREE THAT THE
          LIMITATIONS OF LIABILITY SET FORTH IN THIS SECTION WILL SURVIVE ANY TERMINATION
          OR EXPIRATION OF THIS AGREEMENT. ASU DISCLAIMS ANY REPRESENTATIONS OR
          WARRANTIES, EXPRESSED OR IMPLIED, REGARDING DIGIT, INCLUDING WARRANTIES OF
          FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT.
        </p>
        <p>
          These Terms will be governed by the laws of the State of Arizona without regard
          to any conflicts of laws principles. ASU’s obligations are subject to the
          regulations/policies of the Arizona Board of Regents. Any proceeding arising out
          of or relating to this Agreement or your use of Digit will be conducted in
          Maricopa County, Arizona. You consent to such jurisdiction, and waive any
          objection you may have to venue or convenience of forum.
        </p>
        <p>
          <span style={{ fontWeight: "bold" }}>Dispute Resolution.</span> If a dispute
          arises under the Digit Terms, the parties will exhaust all applicable
          administrative remedies provided for under Arizona Board of Regents Policy
          3-809.
        </p>
        <p>
          <span style={{ fontWeight: "bold" }}>Arbitration.</span> If and to the extent
          required, the parties agree to arbitrate disputes filed in Arizona Superior
          Court that are subject to mandatory arbitration pursuant to ARS § 12-133.
        </p>
        <p>
          Effective: June, 2020{<br />}Updated: December, 2025{<br />}Contact Information:
          If you have any questions or concerns please contact us at:
        </p>
        <p>Email: ASUDigit@asu.edu</p>
        <p>
          You understand that your acceptance below constitutes your consent to the
          collection, use, and disclosure of your personal information for the above
          purposes. If you do not consent, you may not proceed.
        </p>
      </>
    ),

    aiUse: (
      <>
        <p>
          Under no circumstances may ASU content or any publisher content be used with, or
          incorporated into, any artificial intelligence (AI) tools, platforms, or
          systems. This includes—but is not limited to—using such content to train,
          fine-tune, validate, test, or enhance any AI model or service.
        </p>
        <p>
          Students and other users are expressly prohibited from uploading, copying, or
          inputting ASU content or publisher content into AI platforms for any purpose,
          including academic study, tutoring, summarization, rewording, or translation.
          This prohibition applies even if the intent is non-commercial or for personal
          learning. Any such use may violate intellectual property rights and is strictly
          forbidden under these Terms.
        </p>
      </>
    ),
  },
};
